import styled from 'styled-components';
import { space, breakpoints } from 'nicollet-tokens';

const modalHeightValue = height => height === 0 ? '0' : `${height - 20}px`;
/* stylelint-disable unit-no-unknown */


const OptionsList = styled.ul`
  box-sizing: border-box;
  width: 100%;
  min-width: 200px;
  padding: ${props => props.type === 'checkbox' ? space.generic.x1 : '0'};
  padding-left: ${space.generic.x3};
  padding-right: ${space.generic.x3};
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  max-height: ${props => {
  var _a;

  return ((_a = props.style) === null || _a === void 0 ? void 0 : _a.modalHeight) ? modalHeightValue(props.style.modalHeight) : '45vh';
}};
  text-align: left;
  list-style: none;

  margin: 0;

  /* This overrides maxHeight based on modalHeight on medium and smaller screens. */
  @media (max-width: ${breakpoints.md}) {
    max-height: 45vh;
  }

  li:first-child a {
    border-top: none;
  }

  li {
    ${props => props.optionsWidth ? `width: ${props.optionsWidth}px;` : ''};
    margin-bottom: 0;
  }
`;

export { OptionsList };
